import React, {
  forwardRef,
  ForwardRefExoticComponent,
  RefAttributes,
} from "react";
import { FieldProps } from "formik";

import CustomInputNumber, { IInputNumberProps } from "./CustomInputNumber";
import FieldWrapper from "../FieldWrapper/FieldWrapper";
import styles from "./InputNumber.module.scss";
import classNames from "classnames";

interface CustomInputNumberFieldProps
  extends Partial<IInputNumberProps>,
    RefAttributes<HTMLInputElement> {
  label?: string;
  field?: FieldProps["field"];
  meta?: FieldProps["meta"];
  form?: FieldProps["form"];
}

const CustomInputNumberField: ForwardRefExoticComponent<CustomInputNumberFieldProps> =
  forwardRef(({ field, meta, form, label, className, ...rest }, ref) => {
    const hasError = meta?.touched && !!meta?.error;

    return (
      <FieldWrapper error={hasError && meta?.error} label={label}>
        <CustomInputNumber
          ref={ref}
          {...field}
          className={classNames(
            styles.inputNumber,
            {
              [styles.error]: hasError,
            },
            className
          )}
          disabled={form?.isSubmitting || rest.disabled}
          {...rest}
        />
      </FieldWrapper>
    );
  });

export default CustomInputNumberField;
